import React from 'react';
import PropTypes from 'prop-types';
import { FiAlertTriangle } from 'react-icons/fi';

const DeleteConfirmationModal = ({
    title,
    message,
    itemName,
    isLoading,
    confirmLabel,
    loadingLabel,
    confirmClassName,
    onConfirm,
    onCancel,
}) => {
    return (
        <div className="fixed inset-0 z-[200] bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full">
            <div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
                <div className="mt-3 text-center">
                    <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
                        <FiAlertTriangle className="h-6 w-6 text-red-600" />
                    </div>
                    <h3 className="text-lg leading-6 font-medium text-gray-900 mt-4">
                        {title}
                    </h3>
                    <div className="mt-2 px-7 py-3">
                        <p className="text-sm text-gray-500">
                            {message}
                        </p>
                        {itemName && (
                            <p className="text-sm font-medium text-gray-900 mt-2">
                                "{itemName}"
                            </p>
                        )}
                    </div>
                    <div className="flex justify-center gap-4 mt-4">
                        <button
                            onClick={onCancel}
                            disabled={isLoading}
                            className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-300"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={onConfirm}
                            disabled={isLoading}
                            className={`px-4 py-2 text-white rounded-md focus:outline-none focus:ring-2 ${confirmClassName}`}
                        >
                            {isLoading ? loadingLabel : confirmLabel}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

DeleteConfirmationModal.propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    itemName: PropTypes.string,
    isLoading: PropTypes.bool.isRequired,
    confirmLabel: PropTypes.string,
    loadingLabel: PropTypes.string,
    confirmClassName: PropTypes.string,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
};

DeleteConfirmationModal.defaultProps = {
    title: 'Move to trash?',
    message: 'This will move the item to Recent Deletes. You can restore it within 3 months.',
    isLoading: false,
    confirmLabel: 'Move to Trash',
    loadingLabel: 'Moving...',
    confirmClassName: 'bg-red-600 hover:bg-red-700 focus:ring-red-500 disabled:bg-red-300',
};

export default DeleteConfirmationModal;
